import React from 'react';
import './Moldaluminum.css';
import alumin from '../../../imgs/aluminum.webp';


const Moldaluminum = () => {
    return (
        <div className="Material-container">
            <div className='Materialsl'>
                <h2 className="Material-title">Injection Mold Design:</h2>
                <ul className="Plasticcomp-text">
                    <li>Design according to the design with aluminum, customers can choose aluminum or no aluminum.</li>
                </ul>
                <div className="Material">
                    <img src={alumin} alt="72 Cavity PET Preforms Machine" className="Cavity-image" />
                </div>
                <p className="Material-text">The most popular type of thermoplastic material used for
                     LED housings is polycarbonate(PC),
                     which is very strong and can withstand high temperatures.</p>
                <p className="Material-text">Polycarbonate(PC) for LED housings can be
                     molded into countless designs and shapes through injection molding,
                     profile extrusion, sheet or thermoforming processes.</p>
                <p className="Material-text">Powerjet provides injection production solutions for
                     LED bulb covers and housings.
                </p>
                <p className="Material-text">Please feel free to contact us if you are looking for a professional plastic molding machine manufacturer!
                </p>
            </div>
        </div>
    );
};
export default Moldaluminum;
